import { forEach } from "angular";
import { some } from "lodash";

import { AnonymizationLevel } from "./AnonymizationLevel";
import { ImageUpdateStatus } from "./ImageUpdateStatus";
import type { ISiteEquipmentWithCoverages } from "./ISiteEquipmentWithCoverages";
import type { IVideoStream } from "./IVideoStream";
import { ResolutionMode } from "./ResolutionMode";

export class VideoStreamFunctions {
    public static enhanceVideoStream(vs: IVideoStream): IVideoStream {
        vs.anonymizationLevelName = vs.anonymizationLevel as any;
        vs.anonymizationLevel = AnonymizationLevel[vs.anonymizationLevelName as any as keyof typeof AnonymizationLevel];
        vs.resolutionModeName = vs.resolutionMode as any;
        vs.resolutionMode = ResolutionMode[vs.resolutionModeName as any as keyof typeof ResolutionMode];
        vs.latestImageUpdateStatusName = vs.latestImageUpdateStatus as any;
        vs.latestImageUpdateStatus =
            ImageUpdateStatus[vs.latestImageUpdateStatusName as any as keyof typeof ImageUpdateStatus];
        return vs;
    }

    public static enhanceVideoStreams(videoStreams: IVideoStream[]) {
        forEach(videoStreams, (videoStream) => {
            this.enhanceVideoStream(videoStream);
        });
        return videoStreams;
    }

    public static combineVideoStreamLists(
        videoStreams: IVideoStream[],
        camera: ISiteEquipmentWithCoverages,
    ): IVideoStream[] {
        if (camera.masterSiteEquipment) {
            forEach(videoStreams, (vs) => {
                vs.siteEquipmentName = camera.masterSiteEquipment.name;
            });
        }

        forEach(camera.videoStreams, (vs) => {
            vs.siteEquipmentName = camera.name;
            if (!some(videoStreams, (mvs) => vs.id === mvs.id)) {
                videoStreams.push(vs);
            }
        });

        return videoStreams;
    }
}
